export default __webpack_public_path__ + "4c6a4e5553a778c78a05e4adbef06269.png";